import React from "react";
import Chart from "react-google-charts";
import { CardBody, Card, Label, Form, FormGroup, Col, Button, Input, Row } from 'reactstrap'

class MonitoringStatusPieChart extends React.PureComponent {

    render() {
        return (<React.Fragment>
            
                {this.props && this.props.data && this.props.data.length > 0 ?
                   
                    <Chart
                        width={'500px'}
                        height={'300px'}
                        chartType="PieChart"
                        loader={<div className ="monitoring-chart-loader"/>}
                        data={this.props.data}
                        options={{
                            title: this.props.title,
                            is3D: true,
                            fontName: "open_sansregular",
                            legend: {
                                alignment: "center",
                                textStyle: {
                                    color: "233238",
                                    fontSize: 14
                                }
                            },
                            slices: [
                                {
                                    color: "#3366cc"
                                },
                                {
                                    color: "#00b050"
                                },
                                {
                                    color: "#ff0000"
                                },
                                {
                                    color: "#ffff00"
                                },
                                {
                                    color: "#ffff99"
                                },
                                {
                                    color: "#92d050"
                                },
                                {
                                    color: "#7030a0"
                                },
                                {
                                    color: "#ffd966"
                                },
                                {
                                    color: "#0070c0"
                                },
                                {
                                    color: "#fb5433"
                                },
                                {
                                    color: "#ff0000"
                                },
                                {
                                    color: "#ffc000"
                                },
                                {
                                    color: "#e12809"
                                },
                                {
                                    color: "#ec9618"
                                },
                                {
                                    color: "#ca0202"
                                },
                                {
                                    color: "#DADADA"
                                }

                            ]
                        }}
                        rootProps={{ 'data-testid': '2' }}
                    /> 
                    : <div>No data Found!</div>}
            </React.Fragment>
        )
    }


}
export default MonitoringStatusPieChart;